import React, { ChangeEventHandler, FocusEventHandler } from "react"
import classNames from "classnames"

type Props = {
  name: string
  value?: string | number
  onChange?: ChangeEventHandler<HTMLSelectElement>
  onBlur?: FocusEventHandler<HTMLSelectElement>
  withLabel?: boolean
  isError?: boolean
  isDisabled?: boolean
  className?: any
  values?: Array<Object>
  keyId?: string
  keyTitle?: string
}

export default function Select({
  name,
  value,
  onChange,
  onBlur,
  withLabel = false,
  isError = false,
  isDisabled = false,
  className = "",
  values = [],
  keyId = "id",
  keyTitle = "id",
}: Props) {
  let classNameElement = classNames(className, {
    "mt-1": withLabel,
    block: true,
    "w-full": true,
    "pl-3": true,
    "pr-10": true,
    "py-2": true,
    "text-base": true,
    // "shadow-sm": true,
    "sm:text-sm": true,
    "rounded-md": true,
    "border-gray-300": !isError,
    "focus:outline-none": true,
    "focus:ring-indigo-500": !isError,
    "focus:border-indigo-500": !isError,
    "border-red-400": isError,
    "focus:ring-red-500": isError,
    "focus:border-red-500": isError,
    "disabled:opacity-75": isDisabled,
    "disabled:bg-gray-200": isDisabled,
  })

  return (
    <select
      id={name}
      className={classNameElement}
      value={value}
      disabled={isDisabled}
      onBlur={onBlur}
      onChange={onChange}
    >
      {values
        ? values.map((item) => {
            if (!item.hasOwnProperty(keyId)) {
              console.error("value hasn't keyId: ", keyId)
              return
            } else {
              if (!item.hasOwnProperty(keyTitle)) {
                keyTitle = keyId
              }

              return (
                <option key={item[keyId]} value={item[keyId]}>
                  {item[keyTitle]}
                </option>
              )
            }
          })
        : null}
    </select>
  )
}
